import { AiClient, TitleGenerationPayload } from 'api/clients/AiClient'
import { pipe } from 'lodash/fp'
import {
  removeBulletListPrefixes,
  removeNumberedListPrefixes,
  removeSurroundingQuotes,
  trim,
} from 'components/Wizards/sanitisers'

export const generateTitles = async ({
  payload,
  signal,
}: {
  payload: TitleGenerationPayload
  signal?: AbortSignal
}) => {
  const titlesResponse = await AiClient.generateTitles({ payload, signal })

  return titlesResponse.split(/\n/).map(sanitise).filter(Boolean).slice(0, 5)
}

const sanitise = (str: string) =>
  pipe(trim, removeNumberedListPrefixes, removeBulletListPrefixes, removeSurroundingQuotes)(str)
